import React from "react";
import { MicroserviceEventType } from "../types";
import { MicroserviceEventTableActionColumn }  from "./MicroserviceEventTableActionColumn";
import { MicroserviceEventTableColumn } from "./MicroserviceEventTableColumn";
import { TableLoadingRow } from "../../../components/tables/VirtualTable"
import { DateDisplay } from "../../../components";

export type MicroserviceEventTableRowProps = {
    data: MicroserviceEventType[],
    index: number,
    style?: any
};

const MicroserviceEventTableRow = (
    { data, index, style } : Readonly<MicroserviceEventTableRowProps>
) => {
    const { height } = style;

    // do not return a data row when the data has not yet been collected from the backend
    if (index >= data.length) {
        return <TableLoadingRow style={{ height }} />
    }

    const {
        type,
        eventName,
        eventQueue,
        createdDate,
        handledDate,
        totalAttempts
    } = data[index];

    return (
        <tr>
            <MicroserviceEventTableColumn width={6}>
                {type === '0' ? (<span>Inbox</span>) : (<span>Outbox</span>)}
            </MicroserviceEventTableColumn>
            <MicroserviceEventTableColumn>
                {eventName}
            </MicroserviceEventTableColumn>
            <MicroserviceEventTableColumn>
                {eventQueue}
            </MicroserviceEventTableColumn>
            <MicroserviceEventTableColumn className="font-monospace" width={12}>
                <DateDisplay format="DD/MM/YYYY HH:mm:ss">{createdDate}</DateDisplay>
            </MicroserviceEventTableColumn>
            <MicroserviceEventTableColumn className="font-monospace" width={12}>
                {handledDate ? (<DateDisplay format="DD/MM/YYYY HH:mm:ss">{handledDate}</DateDisplay>) : (<span>-</span>)}
            </MicroserviceEventTableColumn>
            <MicroserviceEventTableColumn className="font-monospace text-center" width={5}>
                {totalAttempts}
            </MicroserviceEventTableColumn>
            <MicroserviceEventTableActionColumn data={data[index]} />
        </tr>
    );
};

export default MicroserviceEventTableRow;